import * as React from 'react';
import TextField from '@mui/material/TextField';

 const  SoftBrandingInformation = ({data, onFieldChange, onSave}) => {    //  const [row, setRow] = useState(LicenceData);

    return (
        <div >
            <div style={{display: 'flex', flexDirection: 'column', border: '1px solid #d3d3d3', padding: 5, borderRadius: 5}}>
                
                <div style={{marginLeft:10, marginTop: 10, marginRight: 10}}>
                    <TextField
                        // disabled={!data.logoMainScreen}
                        id="companyName" 
                        label="Company Name" 
                        variant="outlined"
                        className="TextField"
                        fullWidth
                        value={data.companyName}
                        onChange={(event, value) => onFieldChange( event.target.value, event.target.id)}
                        InputLabelProps={{ inputMode: 'string', 
                            shrink: true,
                        }}
                    />
                </div>
               
                <div style={{marginLeft:10, marginTop: 10, marginRight: 10}}>
                    <TextField
                        id="productName" 
                        label="Product Name" 
                        variant="outlined"
                        className="TextField"
                        fullWidth
                        value={data.productName}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'string',
                            shrink: true,
                        }}
                    />
                </div>
                
                <div style={{marginLeft:10, marginTop: 10, marginRight: 10}}>
                    <TextField
                        id="logoMainScreen" 
                        label="Logo Main Screen URL" 
                        variant="outlined"
                        className="TextField"
                        fullWidth
                        value={data.logoMainScreen}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'string',
                            shrink: true,
                        }}
                    />
                </div>
                <div style={{marginLeft:10, marginTop: 10, marginRight: 10}}>
                    <TextField
                        id="logoLoginScreen" 
                        label="Logo Login Screen URL" 
                        variant="outlined"
                        className="TextField"
                        fullWidth
                        value={data.logoLoginScreen}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'string',
                            shrink: true,
                        }}
                    />
                </div>
                <div style={{marginLeft:10, marginTop: 10, marginRight: 10}}>
                    <TextField
                        id="logoClinic" 
                        label="Logo Clinic URL" 
                        variant="outlined"
                        className="TextField"
                        fullWidth
                        value={data.logoClinic}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'string',
                            shrink: true,
                        }}
                    />
                </div>
                <div style={{marginLeft:10, marginTop: 10, marginRight: 10}}>
                    <TextField
                        id="logoSplashScreen" 
                        label="Logo Splash Screen URL" 
                        variant="outlined"
                        className="TextField"
                        fullWidth
                        value={data.logoSplashScreen}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'string',
                            shrink: true,
                        }}
                    />
                </div>
                <div style={{marginLeft:10, marginTop: 10, marginRight: 10}}>
                    <TextField
                        id="logoReport" 
                        label="Logo Report URL" 
                        variant="outlined"
                        className="TextField"
                        fullWidth
                        value={data.logoReport}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'string',
                            shrink: true,
                        }}
                    />
                </div>
                <div style={{marginLeft:10, marginTop: 10, marginRight: 10}}>
                   <TextField
                        id="backgroundImage" 
                        label="Background Image URL" 
                        variant="outlined"
                        className="TextField"
                        fullWidth
                        value={data.backgroundImage}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'string',
                            shrink: true,
                        }}
                    />
                </div>
                {/* <div style={{marginLeft:10, marginTop: 10, marginRight: 10}}>
                    <TextField
                        id="backgroundVideo" 
                        label="Background Video" 
                        variant="outlined"
                        className="TextField"
                        fullWidth
                        value={data.backgroundVideo}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'string',
                            shrink: true,
                        }}
                    />
                </div> */}
                <div style={{marginLeft:10, marginTop: 10, marginRight: 10, width:300}}>
                   <TextField
                        id="applicationColor1" 
                        label="Application Colour 1 (hex)" 
                        variant="outlined"
                        className="TextField"
                        fullWidth
                        value={data.applicationColor1}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'string',
                            shrink: true,
                        }}
                    />
                </div>
                <div style={{marginLeft:10, marginTop: 10, marginRight: 10, width:300}}>
                    <TextField
                         id="applicationColor2" 
                         label="Application Colour 2 (hex)" 
                         variant="outlined"
                         className="TextField"
                         fullWidth
                         value={data.applicationColor2}
                         onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                         InputLabelProps={{  inputMode: 'string',
                             shrink: true,
                         }}
                    />
                </div>
                <div style={{marginLeft:10, marginTop: 10, marginRight: 10, width:300}}>
                     <TextField
                        id="splashScreenColor" 
                        label="Splash Screen Colour (hex)" 
                        variant="outlined"
                        className="TextField"
                        fullWidth
                        value={data.splashScreenColor}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'string',
                            shrink: true,
                        }}
                    />
                </div> 
                <div style={{marginLeft:10, marginTop: 10, marginRight: 10}}>
                    <TextField
                        id="website" 
                        label="Website" 
                        variant="outlined"
                        className="TextField"
                        fullWidth
                        value={data.website}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'string',
                            shrink: true,
                        }}
                    />
                </div>
                <div style={{marginLeft:10, marginTop: 10, marginRight: 10}}>
                    <TextField
                        id="manualLink" 
                        label="Manual Link" 
                        variant="outlined"
                        className="TextField"
                        fullWidth
                        value={data.manualLink}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'string',
                            shrink: true,
                        }}
                    />
                </div>
                <div style={{marginLeft:10, marginTop: 10, marginRight: 10}}>
                    <TextField
                        id="correctivesLink" 
                        label="Correctives Link" 
                        variant="outlined"
                        className="TextField"
                        fullWidth
                        value={data.correctivesLink}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'string',
                            shrink: true,
                        }}
                    />
                </div>
                <div style={{marginLeft:10, marginTop: 10, marginRight: 10}}>
                    <TextField
                        id="supportWebsite" 
                        label="Support Website" 
                        variant="outlined"
                        className="TextField"
                        fullWidth
                        value={data.supportWebsite}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'string',
                            shrink: true,
                        }}
                    />
                </div>
                <div style={{marginLeft:10, marginTop: 10, marginRight: 10}}>
                    <TextField
                        id="supportEmail" 
                        label="Support Email" 
                        variant="outlined"
                        className="TextField"
                        fullWidth
                        value={data.supportEmail}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'string',
                            shrink: true,
                        }}
                    />
                </div>
                {/* <div style={{marginLeft:10, marginTop: 10, marginRight: 10}}>
                    <TextField
                        id="customTerms" 
                        label="Custom Terms" 
                        variant="outlined"
                        className="TextField"
                        fullWidth
                        value={data.customTerms}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'string',
                            shrink: true,
                        }}
                    />
                </div> */}
                {/* <div style={{marginLeft:10, marginTop: 10, marginRight: 10, }}>
                    <TextField
                        id="regions" 
                        label="Regions" 
                        variant="outlined"
                        className="TextField"
                        fullWidth
                        value={data.regions}
                        onChange={(event, value) => onFieldChange( (event.target.value), event.target.id)}
                        InputLabelProps={{  inputMode: 'string',
                            shrink: true,
                        }}
                    />
                </div> */}
                
            </div>
        </div>
    );
   
}

export default SoftBrandingInformation;